


























import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component} from "vue-property-decorator";
import {DistrictStore} from "@/modules/regionsv2/district/store";
import {FormModel} from "ant-design-vue";
import ProvinceSelectorV2 from "@/modules/regionsv2/ProvinceSelectorV2/index.vue";

const form = {
    name: undefined,
    provinceId: undefined
}
@Component({
    name: "DistrictForm",
    components: {ProvinceSelectorV2}
})
export default class extends mixins(CommonMixin) {
    form = { ...form };
    rules = {
        name: [{ required: true, message: "Nhập tên phường/xã" }],
        provinceId: [{ required: true, message: "Chọn tỉnh" }],
    }
    submit() {
        (this.$refs.form as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                await DistrictStore.createDistrictV21(this.form);
                this.resetForm();
                this.$message.success("Tạo phường/xã thành công");
            } catch (e) {
                this.$message.success("Tạo phường/xã thất bại");
            }
        })
    }
    resetForm() {
        this.form = { ...form };
    }
}
